import React from 'react';

import { KIND, blocks_submit } from './error_handlers';

/*
 * pieces every penalties dialog shares: the error box (the refusal renders inside the dialog that
 * sent it), the mandatory note and the footer.
 */

export const ErrorBox = ({ error }) =>
  error ? (
    <div
      className={`tp-banner ${error.kind === KIND.CONFIRM ? 'tp-banner-warn' : 'tp-banner-error'}`}
      role="alert"
    >
      {error.text}
    </div>
  ) : null;

// field: the server's per-field message (error.fields) or this form's own check.
export const FieldError = ({ text }) => (text ? <span className="tp-err">{text}</span> : null);

// No maxLength: it counts units and truncates silently; note_error counts code points.
export const NoteField = ({ id, label, value, on_change, error_text, placeholder }) => (
  <div className="tp-field">
    <label htmlFor={id}>{label}</label>
    <textarea
      id={id}
      className="tp-textarea"
      value={value}
      placeholder={placeholder}
      onChange={(e) => on_change(e.target.value)}
    />
    <FieldError text={error_text} />
  </div>
);

/*
 * A CONFIRM error turns the primary button into the confirmation (it resends with the flag); STALE
 * and ALREADY_SAVED leave only Close, since resending the same request can only be refused again.
 */
export const DialogFooter = ({
  saving,
  error,
  submit_label,
  confirm_label = 'Confirm and save',
  danger = false,
  on_submit,
  on_confirm,
  on_close
}) => {
  const blocked = blocks_submit(error);
  const confirming = !!error && error.kind === KIND.CONFIRM;
  const primary = confirming ? on_confirm : on_submit;
  return (
    <div className="tp-modal-ft">
      <button
        type="button"
        className="tp-btn-ghost"
        onClick={saving ? undefined : on_close}
        aria-disabled={saving ? 'true' : undefined}
      >
        {blocked ? 'Close' : 'Cancel'}
      </button>
      {blocked ? null : (
        <button
          type="button"
          className={`tp-btn${danger && !confirming ? ' tp-btn-danger' : ''}`}
          onClick={saving ? undefined : primary}
          aria-disabled={saving ? 'true' : undefined}
        >
          {saving ? 'Saving…' : confirming ? confirm_label : submit_label}
        </button>
      )}
    </div>
  );
};

// The row the dialog acts on, in one line (no dangling " · " when a part is empty).
export const RowContext = ({ row }) => (
  <div className="tp-ctx">
    <b>{row.teacher_name}</b>
    {[row.short_id, row.session_text, row.type_text, `Charged ${row.charged_text}`]
      .filter(Boolean)
      .map((part) => (
        <span key={part}> · {part}</span>
      ))}
    {row.override_text ? <div>{row.override_text}</div> : null}
    {(row.join_lines || []).length ? (
      <div data-join-times>{row.join_lines.map((l) => `${l.label}: ${l.value}`).join(' · ')}</div>
    ) : null}
    {row.note ? <div>Note: {row.note}</div> : null}
  </div>
);
